module.exports = __webpack_public_path__ + "static/img/img-yybs.b5c138e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/mob/img-yybs.png
// module id = vIHM
// module chunks = 0